import { CHANGE_HEADER_LOADING, CHANGE_HEADER_SUCCESS, CHANGE_HEADER_FAILED } from "../types"

const initialState = {
  loading: false,
  error: false,
  numPaxes: {},
}

export default function (state = initialState, action) {
  switch (action.type) {
    case CHANGE_HEADER_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
        numPaxes: null,
      }
    case CHANGE_HEADER_FAILED:
      return {
        ...state,
        loading: false,
        error: true,
        numPaxes: null,
      }
    case CHANGE_HEADER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        numPaxes: action.payload,
      }
    default:
      return state
  }
}
